<div class="flex h-full min-h-0 w-full flex-col gap-4">
	<div>
		<h1 class="text-3xl font-bold">
			<span [translate]>User Management</span>
		</h1>
		<p class="text-base-content/60 mt-2 text-sm">
			<span [translate]>Inspect platform users and perform admin actions.</span>
		</p>
	</div>

	<div class="min-h-0 flex-1">
		<lib-user-table
			class="block h-full w-full"
			bypass-acls="true"
			click-behavior="emit"
			[queryForSearchPatternInUrl]="'admin-users'"
			(rowClicked)="goToUserBuilder($event.id)"
		></lib-user-table>
	</div>
</div>
